import { configureStore } from "@reduxjs/toolkit"

import { IS_DEVELOPMENT } from "../env-management"

import { rootReducer } from "./reducer"
import { surveyListenerMiddleware } from "./slices"

const store = configureStore({
    reducer: rootReducer,
    devTools: IS_DEVELOPMENT,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Игнорируем предупреждения для несериализуемых данных (ServicesGroup, Date)
                ignoredActions: [
                    "booking/setServiceGroups",
                    "booking/setServiceGroup",
                    "booking/setSelectedService",
                    "booking/setSelectedTime",
                    "booking/setSelectedDayOfMonth",
                    "booking/setCurrentWeek",
                    "booking/changeSelectedTime",
                    "booking/restoreBookingState",
                ],
                ignoredPaths: [
                    "booking.serviceGroups",
                    "booking.serviceGroup",
                    "booking.selectedService",
                    "booking.selectedTime",
                    "booking.selectedDayOfMonth",
                    "booking.currentWeek",
                ],
            },
        }).concat(surveyListenerMiddleware.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export { store }
